// extracted by mini-css-extract-plugin
export default {"statusSelect":"style_statusSelect__khnTy","statusSelectNonActive":"style_statusSelectNonActive__JY8uf","statusSelectActive":"style_statusSelectActive__7qNLv"};